import { InsertRowLeftOutlined, UndoOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Checkbox,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Popconfirm,
  Row,
  Space,
  Table,
  Tooltip,
} from "antd";
import "antd/dist/antd.min.css";
import { debounce } from "lodash";
import React, { useEffect, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { postRequest } from "../../axios";
import ButtonField from "../../common/htmlComponents/ButtonField";
import SearchIcon from "../../image/SearchIcon.svg";
import "../../styles/Main.scss";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";

const { Search } = Input;

const ActivityLogList = () => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [selectedRow, setSelectedRow] = useState([]);
  // const [loading, setLoading] = useState(false);
  const [requestedDemoList, setRequestedDemoList] = useState([]);
  // const [totalCount, settotalCount] = useState(0);
  const [reload, setReload] = useState(false);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getActivityLogList = async () => {
      // setLoading(true);

      // try {
      //   let apiResponse = await getRequest("request-demo/", state);

      //   if (apiResponse.data.results.success) {
      setRequestedDemoList([]);
      //     settotalCount(apiResponse.data.count);
      //   } else {
      //     ErrorNotificationMsg(t("error_in_activity_log_list"));
      //   }
      //   setLoading(false);
      // } catch (error) {
      //   setLoading(false);
      // }
    };

    getActivityLogList();
  }, [state, reload, t]);

  const handleReset = () => {
    setState({
      ...state,
      search: "",
    });
    // setState({
    //   ...state,
    //   search: "",
    //   status: "",
    //   page: 1,
    // });
    form.setFieldsValue({ search: "" });
  };
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";

    if (sortField === "company_name" && sortOrder === "ascend") {
      sortingEnumKey = "company_name";
    }
    if (sortField === "company_name" && sortOrder === "descend") {
      sortingEnumKey = "-company_name";
    }
    if (sortField === "person_name" && sortOrder === "ascend") {
      sortingEnumKey = "person_name";
    }
    if (sortField === "person_name" && sortOrder === "descend") {
      sortingEnumKey = "-person_name";
    }
    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }
    if (sortField === "email" && sortOrder === "ascend") {
      sortingEnumKey = "email";
    }
    if (sortField === "email" && sortOrder === "descend") {
      sortingEnumKey = "-email";
    }
    if (sortField === "phone" && sortOrder === "ascend") {
      sortingEnumKey = "phone";
    }
    if (sortField === "phone" && sortOrder === "descend") {
      sortingEnumKey = "-phone";
    }
    if (sortField === "country" && sortOrder === "ascend") {
      sortingEnumKey = "country";
    }
    if (sortField === "country" && sortOrder === "descend") {
      sortingEnumKey = "-country";
    }
    if (sortField === "detail" && sortOrder === "ascend") {
      sortingEnumKey = "detail";
    }
    if (sortField === "detail" && sortOrder === "descend") {
      sortingEnumKey = "-detail";
    }
    if (sortField === "ip_address" && sortOrder === "ascend") {
      sortingEnumKey = "ip_address";
    }
    if (sortField === "ip_address" && sortOrder === "descend") {
      sortingEnumKey = "-ip_address";
    }
    if (sortField === "log_time" && sortOrder === "ascend") {
      sortingEnumKey = "log_time";
    }
    if (sortField === "log_time" && sortOrder === "descend") {
      sortingEnumKey = "-log_time";
    }

    return sortingEnumKey;
  };
  const [checkedList, setCheckedList] = useState([
    "company_name",
    "person_name",
    "email",
    "phone",
    "country",
    "detail",
    "ip_address",
    "log_time",
  ]);
  const [columns, setColumns] = useState([
    {
      title: "Company Name",
      dataIndex: "company_name",
      key: "company_name",
      sorter: true,
    },
    {
      title: "Person Name",
      dataIndex: "person_name",
      sorter: true,
      key: "person_name",
    },
    {
      title: "Email",
      dataIndex: "email",
      sorter: true,
      key: "email",
    },
    {
      title: "Phone Or Whatsapp Number",
      dataIndex: "phone",
      render: (phone) => <>+{phone} </>,
      sorter: true,
      key: "phone",
    },
    {
      title: "Country",
      dataIndex: "country",
      sorter: true,
      key: "country",
    },

    {
      title: "Detail",
      dataIndex: "detail",
      sorter: true,
      key: "detail",
    },
    {
      title: "IP Address",
      dataIndex: "ip_address",
      sorter: true,
      key: "ip_address",
    },
    {
      title: "Log Time",
      dataIndex: "log_time",
      sorter: true,
      key: "log_time",
    },
  ]);

  useEffect(() => {
    const updatedColumns = columns.map((column) => ({
      ...column,
      hidden: !checkedList.includes(column.key),
    }));
    setColumns(updatedColumns);
  }, [checkedList, columns]);

  const handleColumnVisibilityChange = (checkedValues) => {
    setCheckedList(checkedValues);
  };

  // const columnMenu = (
  //   <Menu>
  //     <Menu.Item>
  //       <Checkbox.Group
  //         value={checkedList}
  //         onChange={handleColumnVisibilityChange}
  //       >
  //         <Row>
  //           <Col span={12}>
  //             <Checkbox value="company_name">Company Name</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="person_name">Person Name</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="email">Email</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="phone">Phone Or Whatsapp Number</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="country">Country</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="detail">Details</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="ip_address">IP Address</Checkbox>
  //           </Col>
  //           <Col span={12}>
  //             <Checkbox value="log_time">Log Time</Checkbox>
  //           </Col>
  //         </Row>
  //       </Checkbox.Group>
  //     </Menu.Item>
  //   </Menu>
  // );
  
   const allColumns = [
      { key: "company_name", title: "Company Name" },
      { key: "person_name", title: "Person Name" },
      { key: "email", title: "Email" },
      { key: "phone", title: "Phone Or Whatsapp Number" },
      { key: "country", title: "Country" },
      { key: "detail", title: "Details" },
      { key: "ip_address", title: "IP Address" },
      { key: "log_time", title: "Log Time" },
    ];
    
    const columnMenu = (
      <Menu className="packagelistdropdown">
        <Menu.Item>
          <Checkbox.Group
            value={checkedList}
            onChange={handleColumnVisibilityChange}
          >
            <Row>
              {allColumns.map((column) => (
                <Col span={12} key={column.key}>
                  <Checkbox
                    value={column.key}
                    disabled={column.key === "operation"}
                  >
                    {column.title}
                  </Checkbox>
                </Col>
              ))}
            </Row>
          </Checkbox.Group>
        </Menu.Item>
      </Menu>
    );
  
  const handleArchive = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("request-demo-delete/", {
        deleted: ids,
      });
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("activity_log_archive_successfully"));
        setReload(!reload);
        setSelectedRow([]);
      } else {
        ErrorNotificationMsg(t("error_in_archive_activity_log"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };

  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const colors = ["#737373"];
  return (
    <>
     <div className="mainwrapper">
        <div className="ListingTopBar">
          <div className="pagenamewrap">
            <div className="pagename">
              {/* <Tooltip
                color={colors}
                placement="right"
                title={
                  <span style={{ color: "#fff" }}>
                    Track and review all activity within your delivery system.
                  </span>
                }
              > */}
              <h3>{t("pl_activity_log")}</h3>
              {/* </Tooltip> */}

              <Breadcrumb className="Breadcrumb-Sec">
                <Breadcrumb.Item>
                  <Link to="/dashboard">{t("home")}</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>{t("pl_activity_log")}</Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <Space>
              <div className="searchwrp" style={{ height: "40px" }}>
                <Space direction="vertical">
                  <Form form={form}>
                    <Form.Item name="search" initialValue="">
                      <Search
                        // value={state.search}
                        prefix={
                          <img
                            src={SearchIcon}
                            alt="SearchIcon"
                            className="SearchIcon"
                            width={22}
                          />
                        }
                        placeholder={t("pl_search_list")}
                        onChange={searchCallbackDelayed}
                        style={{
                          width: 250,
                        }}
                      />
                    </Form.Item>
                  </Form>
                </Space>
              </div>
              {state?.search ? (
                // <Tooltip title="Reset search">
                <Button
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  onClick={() => handleReset()}
                  label={
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <UndoOutlined
                        style={{ fontSize: "16px", color: "#fff" }}
                      />{" "}
                      Reset
                    </span>
                  }
                ></Button>
              ) : (
                // </Tooltip>

                ""
              )}

              {selectedRow.length > 0 && (
                <Popconfirm
                  className="action"
                  title={t("pop_title")}
                  okText={t("pop_ok")}
                  cancelText={t("pop_cancel")}
                  placement="left"
                  onConfirm={() => handleArchive()}
                >
                  <ButtonField
                    className="BlueShadowBtn"
                    type="primary"
                    htmlType="button"
                    label={t("pl_archive")}
                  />
                </Popconfirm>
              )}
              <div className="gridiconswrap">
                {/* <Tooltip placement="topLeft" title="Column Filter Options"> */}
                <Dropdown
                  overlay={columnMenu}
                  trigger={["click"]}
                  placement="bottomRight"
                  visible={dropdownVisible}
                  onVisibleChange={(visible) => setDropdownVisible(visible)}
                >
                  <Button
                    type="primary"
                    shape="circle"
                    icon={<InsertRowLeftOutlined />}
                    onClick={() => setDropdownVisible(!dropdownVisible)}
                  />
                </Dropdown>
                {/* </Tooltip> */}
              </div>
              {/* {authUserData()?.permission.includes("company|delete_company") && (
              <Tooltip placement="topLeft" title="Archived Records">
                <Link to="/activity-log/archive" className="Archiveicon">
                  <Archiveicon />
                </Link>
              </Tooltip>
                )} */}
            </Space>
          </div>
        </div>
      
      <section className="grid-sec">
         <div className="Package-body">
          <div className="tablewrp">
          <Row className="tblheader">
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-heading">
            <h1>{t("pl_activity_log")}</h1>
          </Col> */}
            {/* <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
            <div className="searchwrp">
              <Space direction="vertical">
                <Search
                  prefix={
                    <img
                      src={SearchIcon}
                      alt="SearchIcon"
                      className="SearchIcon"
                      width={22}
                    />
                  }
                  placeholder={t("pl_search_list")}
                  onChange={searchCallbackDelayed}
                  style={{
                    width: 250,
                  }}
                />
              </Space>
            </div>

            {selectedRow.length > 0 && (
              <Popconfirm
                className="action"
                title={t("pop_title")}
                okText={t("pop_ok")}
                cancelText={t("pop_cancel")}
                placement="left"
                onConfirm={() => handleArchive()}
              >
                <ButtonField
                  className="BlueShadowBtn"
                  type="primary"
                  htmlType="button"
                  label={t("pl_archive")}
                />
              </Popconfirm>
            )}
            <Tooltip placement="topLeft" title="Archived Records">
              <Link to="/activity-log/archive" className="Archiveicon">
                <Archiveicon />
              </Link>
            </Tooltip>
            
          </Col> */}
          </Row>
          <Table
            scroll={{
              x: 1500,
            }}
            rowSelection={rowSelection}
            rowKey={(record) => record.id}
            // columns={columns}
            columns={columns.filter((col) => !col.hidden)}
            dataSource={requestedDemoList}
            // loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              // total: totalCount,
              showTotal: (total) => `Total ${total} items`,
              showSizeChanger: true,
              locale: {
                items_per_page: "Items / Page", // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
        </div></div>
      </section>
      </div>
    </>
  );
};

export default ActivityLogList;
